export default {
	apiKey: "AIzaSyCAMhYJVCmBXSbbIkYp_6bwjt3j6rauPb4",
	authDomain: "ayun-quantity-prod.firebaseapp.com",
	projectId: "ayun-quantity-prod",
	storageBucket: "ayun-quantity-prod.appspot.com",
	messagingSenderId: "644294583113",
	appId: "1:644294583113:web:fc77290e14ac90e708b098",
	measurementId: "G-X1WCK2LJZW"
};
